// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const GoTo = ($timeout: any) => ({
   link(scope: any, el: any, attrs: any) {
      el.on('focus', function() {
         const modal = angular.element("div.modal")
         if (modal.is(":visible")) {
            return modal.filter(":visible").focus()
         } else {
            return el.closest('li').removeClass('offscreen').closest('.skipnav').removeClass('offscreen')
         }
      }).on('blur', () => el.closest('li').addClass('offscreen').closest('.skipnav').addClass('offscreen')).on('keypress click', function(e: any) {
         if (attrs.goTo !== "") {
            // if clicking or pressing Enter/Space
            if ((e.type === "click") || ((e.type === "keypress") && ((e.keyCode === 13) || (e.keyCode === 32)))) {
               // close all menus and fullDialogs
               let goTo: string | undefined
               scope.closeAllMenuTypeSubMenu()
               // go-to-force links (e.g. skip to search box) always navigate to their
               // explicit target rather than being redirected to the open dialog's content
               if (attrs.goToForce === undefined) {
                  if (scope.saveditems?.visible) { goTo = '#savedItemsContent' }
                  if (scope.savedSearch?.visible) { goTo = '#savedSearchContent' }
                  if (scope.docDetail?.visible) { goTo = '#detailSummary' }
               }
               // open a closed floating panel so its target becomes focusable
               let panelOpened = false
               if (attrs.goToOpen && scope.menu?.[attrs.goToOpen] && !scope.menu[attrs.goToOpen].open) {
                  scope.menu[attrs.goToOpen].openMenu(true)
                  panelOpened = true
               }
               // close a floating open panel so it no longer overlays results
               if (attrs.goToClose && scope.menu?.[attrs.goToClose]?.floating && scope.menu[attrs.goToClose].open) {
                  scope.menu[attrs.goToClose].closeMenu(true)
               }
               scope.$apply()
               const target: string = goTo || attrs.goTo
               // now that the menus and fullDialogs are closed...
               // use $timeout when a panel was just opened so ng-show has made the target visible
               if (panelOpened) {
                  return $timeout(() => angular.element(target).attr('tabindex', -1).focus())
               }
               return angular.element(target).attr('tabindex', -1).focus()
            }
         }
      })
      return scope.$on('$destroy', () => el.off('focus blur keypress click'))
   }
})

const DisableEnter = () => ({
   link(scope: any, el: any, attrs: any) {
      return el.on('keypress', function(e: any) {
         if ((e.type === "keypress") && (e.keyCode === 13)) {
            return e.preventDefault()
         }
      })
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter '$document' implicitly has an 'any' type... Remove this comment to see the full error message
const KeyEvents = ($document, localizationService, dialog) => ({
   link(scope: any) {
      const {
         isRTL
      } = localizationService.localization
      return $document.on('keyup', function(e: any) {
         const view = {
            search: (scope.view === "search") && !scope.search.advanced && !scope.menu.facets.open && !scope.subMenu.links.open,
            facetsMenu: scope.menu.facets.open,
            thirdPanel: scope.menu.thirdPanel.open,
            linksMenu: scope.subMenu.links.open,
            saveditems: scope.saveditems.visible,
            detailsPage: scope.docDetail.visible,
            advancedSearch: scope.search.advanced,
            modal: angular.element("div.modal").is(":visible")
         }
         const key = {
            esc: 27,
            tab: 9,
            enter: 13,
            space: 32,
            up: 38,
            down: 40,
            left: isRTL ? 39 : 37, //flip left/right when isRTL
            right: isRTL ? 37 : 39 //flip left/right when isRTL
         }
         // @ts-expect-error TS(2769) FIXME: No overload matches this call.
         const focusEl = angular.element(document.activeElement)
         const textEl = angular.element("input[type=text], input[type=email], textarea")
         const facetsPane = angular.element("div.refinePane")
         const linksMenu = angular.element("div.linksMenu")
         const moreFacetsCloseBtn = angular.element("#moreFacetsCloseBtn")
         const resultsPane = angular.element("#results")
         const rightPane = angular.element("#rightPane")
         const queryBox = angular.element("div.queryBox input[type=text]")
         const result = focusEl.closest("#results > .inner > ul > li")
         const savedResult = focusEl.closest("div.citation-content ul > li")
         const prevResult = result.prev()
         const nextResult = result.next()
         const documentSummary = result.find("div.documentSummary")
         const activeResult = angular.element("li.activeResult")
         const menuCloseButton = angular.element("#menuContentOverlay")
         const savedItemsDialog = angular.element("div.savedItemsDialog")
         const mainDiv = angular.element("#main")
         const detailPage = angular.element("div.detailPage")
         const navigateBack = angular.element("div.navigateBack")
         const lastHeaderItem = angular.element("div.siteHeader *:tabbable:last")
         const advancedSearchDialog = angular.element("div.advancedSearchDialog")
         const modal = angular.element("div.modal:visible")
         const dropdown = angular.element(".dropdown-menu")
         const isDropdownVisible = dropdown.is(":visible")
         const hasFocus = function(elm: any, onlyParent = false) {
            if (onlyParent) { return focusEl.is(elm) }
            return focusEl.is(elm) || (focusEl.closest(elm).length > 0)
         }
         const closeMenus = function() {
            dialog.isClosing = false
            scope.closeAllMenuTypeSubMenu()
            return scope.$apply()
         }

         switch (e.which) {
            case key.esc:
               if (scope.chat?.visible) {
                  scope.chat.visible = false
                  if (scope.collapsed !== undefined) {
                     scope.collapsed = false
                  }
                  scope.$apply()
                  break
               }
               if (scope.areAllMenuTypeSubMenuClosed() && !hasFocus(queryBox) && !dialog.isClosing) {
                  queryBox.focus()
               } else {
                  closeMenus()
               }
               break
         }

         if (hasFocus(textEl)) { return }

         switch (e.which) {
            case key.enter:
               if (!!focusEl.attr("ng-click") && !focusEl.is("button")) {
                  focusEl.trigger("click")
               } else if (focusEl.hasClass("lcs_slide_out") || focusEl.hasClass("s-la-widget-sidetab-a")) {
                  // handle clicks on springshare V2 slide out widgets
                  if (focusEl.is("a")) {
                  // NOTE: springshare systems widget 'tab' style does not open dialog on click
                     focusEl.trigger("click")
                  } else {
                     focusEl.find("a").trigger("click")
                  }
               }
               break

            case key.space:
               if ((focusEl.attr("data-aid") === "chat-launcher") || focusEl.hasClass("chatHeaderButton")) {
                  e.preventDefault()
                  focusEl.trigger("click")
               }
               break
         }

         switch (true) {

            case view.linksMenu:
               return menuCloseButton.on('blur', () => linksMenu.focus())

            case view.modal:
               if ((e.which === key.tab) && !hasFocus(modal)) { return modal.focus() }
               break

            case view.saveditems:
               switch (e.which) {
                  case key.tab:
                     if (hasFocus(mainDiv)) { savedItemsDialog.focus() }
                     if (hasFocus(mainDiv) && e.shiftKey) { return lastHeaderItem.focus() }
                     break

                  case key.up:
                     if (hasFocus(savedItemsDialog, true)) { savedItemsDialog.find("div.citation-content ul > li:first").focus() }
                     if (hasFocus(savedItemsDialog) && !focusEl.is("button.dropdown-toggle")) { return savedResult.prev().focus() }
                     break

                  case key.down:
                     if (hasFocus(savedItemsDialog, true)) { savedItemsDialog.find("div.citation-content ul > li:first").focus() }
                     if (hasFocus(savedItemsDialog) && !focusEl.is("button.dropdown-toggle")) { return savedResult.next().focus() }
                     break
               }
               break

            case view.detailsPage:
               if (e.which === key.tab) {
                  if (hasFocus(mainDiv)) { detailPage.focus() }
                  if (hasFocus(mainDiv) && e.shiftKey) { return lastHeaderItem.focus() }
               }
               break

            case view.advancedSearch:
               if (e.which === key.tab) {
                  if (hasFocus(mainDiv)) { advancedSearchDialog.focus() }
                  if (hasFocus(mainDiv) && e.shiftKey) { return lastHeaderItem.focus() }
               }
               break

            case view.facetsMenu:
               if (!view.linksMenu && (e.which === key.enter) && hasFocus(moreFacetsCloseBtn)) { facetsPane.focus() }
               if (scope.menu.facets.floating && (e.which === key.esc)) {
                  scope.menu.facets.closeMenu()
                  return scope.$apply()
               }
               break
     
            case view.thirdPanel:
               if (scope.menu.thirdPanel.floating && (e.which === key.esc)) {
                  scope.menu.thirdPanel.closeMenu()
                  return scope.$apply()
               }
               break

            case view.search:
               if (!isDropdownVisible) {
                  switch (e.which) {
                     case key.up:
                        if (!focusEl.is('.self-key-binding')) {
                           if (hasFocus(resultsPane, true)) { resultsPane.find("div.inner > ul > li:first").focus() }
                           if (hasFocus(resultsPane) && !focusEl.is("button.dropdown-toggle")) { return prevResult.focus() }
                        }
                        break

                     case key.down:
                        if (!focusEl.is('.self-key-binding')) {
                           if (hasFocus(resultsPane, true)) { resultsPane.find("div.inner > ul > li:first").focus() }
                           if (hasFocus(resultsPane) && !focusEl.is("button.dropdown-toggle")) { return nextResult.focus() }
                        }
                        break

                     case key.left:
                        if (!focusEl.is('.self-key-binding')) {
                           switch (true) {
                              case hasFocus(rightPane): resultsPane.focus(); break
                              default:  facetsPane.focus()
                           }
                           // and scroll to top: SMN-431
                           return window.scrollTo(0, 0)
                        }
                        break

                     case key.right:
                        if (!focusEl.is('.self-key-binding')) {
                           switch (true) {
                              case hasFocus(resultsPane, true): rightPane.focus(); break
                              case rightPane.is(":visible"): rightPane.focus(); break
                              default: resultsPane.focus()
                           }
                           // and scroll to top: SMN-431
                           return window.scrollTo(0, 0)
                        }
                        break
                  }
               }
               break
         }
      })
   }
})

const FocusMe = ($timeout: any) => ({
   link(scope: any, element: any, attrs: any) {
      return scope.$watch(attrs.focusMe, function(value: any) {
         if (!!value) {
            return $timeout(() => element[0].focus())
         }
      })
   }
})

angular.module('summonApp.directives')
   .directive('goTo', ['$timeout', GoTo])
   .directive('disableEnter', DisableEnter)
   .directive('keyEvents', ['$document', 'localizationService', 'dialogService', KeyEvents])
   .directive('focusMe', ['$timeout',FocusMe])
